import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from './root'

const createRedirectRoute = (oldPath: string, newPath: string) =>
  createRoute({
    getParentRoute: () => rootRoute,
    path: oldPath,
    beforeLoad: async ({ params }) => {
      throw redirect({
        to: newPath,
        params,
        replace: true,
      })
    },
  })

const routesMap: [string, string][] = [
  ['/shipment/$id/shipping-documents', '/shipments/$id/documents'],
  ['/shipment/$id/cost-breakdown', '/shipments/$id/price-breakdown'],
  ['/shipment/$id/shipping-instructions', '/shipments/$id/details'],
  ['/shipment/$id/$', '/shipments/$id'], // Fallback for overview, activity feed, and any other pages
  ['/bookings', '/'], // bookings and shipments are both listed on the same page in Ship-v2
  ['/invoices', '/billing'],
  ['/quote-sheet/$', '/quotes'], // don't show quote sheet details on ship-v2
  ['/quote-request/$', '/bookings/create'], // This covers new quotes and saved templates, since there's no direct equivalent in Ship-v2
  ['/notification-center/settings/$path', '/notification-center/settings'], // covers /preferences and /advanced
  ['/directory/organization/$id', '/'], // Ship-v2 doesn't have the "Company Account" page currently
  ['/company/activity', '/'], // Ship-v2 doesn't have the "Company Activity" page currently
  ['/company/users/$path', '/company/users'], // covers /create and /$id, for create and edit user pages which are modals without urls here
  ['/tracking', '/'], // Ship-v2 doesn't have a dedicated tracking page
  ['/booking-requests', '/'], // don't show booking requests on ship-v2
  ['/reports/edit', '/reports/create'], // /edit is the page for creating reports in ship-v1
]

export const redirectShipV1Routes = routesMap.map(([oldPath, newPath]) => createRedirectRoute(oldPath, newPath))
